import { Box } from '@mui/material'
import { ReactNode, useEffect, useState } from 'react'
import { GroupDoc } from 'types/api/changes'
import { Model } from 'types/model'
import { isCalendarLinkingAllowed } from 'utils/api/groups'

import MemberCanSection from '../groupInfo/MembersCanSection'
import * as Styled from '../styled'
import { useAddGroup } from './AddGroupProvider'

interface MemberCanPopupInterface {
  children: ReactNode
  group: Model<GroupDoc>
  open?: boolean
  setOpen: (b: boolean) => void
}

function MemberCanPopupContent(props: MemberCanPopupInterface) {
  const addGroupProvider = useAddGroup()
  const [calendarLinkingState, setCalendarLinkingState] = useState<string>(
    isCalendarLinkingAllowed(props.group) ? '1' : '0'
  )

  useEffect(() => {
    setCalendarLinkingState(isCalendarLinkingAllowed(props.group) ? '1' : '0')
  }, [props.group])

  return (
    <Box pl={4} pr={4}>
      <Box height={'1rem'} />{' '}
      <MemberCanSection
        setError={() => {}}
        setLoading={() => {}}
        error=""
        account={props.group.Account}
        group={props.group}
        eventDetailsState={addGroupProvider.eventsDetailsState}
        calendarLinkingState={calendarLinkingState}
        calendarLinkingCheck={(checked) => {
          setCalendarLinkingState(checked ? '1' : '0')
        }}
        metaDataState={addGroupProvider.metaDataState}
        allCanAddItemsState={addGroupProvider.allCanAddItemsState}
        addParticipantsState={addGroupProvider.addParticipantsState}
        eventOwnershipState={addGroupProvider.eventOwnershipState}
        eventOwnershipCheck={() => {
          const oldState = addGroupProvider.eventOwnershipState
          const newState = oldState === '1' ? '0' : '1'
          addGroupProvider.setEventOwnershipState(newState)

          if (
            addGroupProvider.allCanAddItemsState === '0' &&
            newState === '1'
          ) {
            addGroupProvider.setAllCanAddItemsState('1')
          }
        }}
        addParticipantsCheck={() => {
          const newState =
            addGroupProvider.addParticipantsState === '1' ? '0' : '1'
          addGroupProvider.setAddParticipantsState(newState)
        }}
        allCanAddItemsCheck={() => {
          const oldState = addGroupProvider.allCanAddItemsState
          const newState = oldState === '1' ? '0' : '1'
          addGroupProvider.setAllCanAddItemsState(newState)

          if (
            addGroupProvider.eventOwnershipState === '1' &&
            newState === '0'
          ) {
            addGroupProvider.setEventOwnershipState('0')
          }
        }}
        groupMetaDataCheck={() => {
          const newState = addGroupProvider.metaDataState === '1' ? '0' : '1'
          addGroupProvider.setMetaDataState(newState)
        }}
        eventDetailsCheck={() => {
          const newState =
            addGroupProvider.eventsDetailsState === '1' ? '0' : '1'
          addGroupProvider.setEventsDetailsState(newState)
        }}
      />
    </Box>
  )
}

export default function MemberCanPopup(props: MemberCanPopupInterface) {
  return (
    <Styled.MembersCanPopup
      open={props.open}
      setOpen={props.setOpen}
      placement="left"
      content={<MemberCanPopupContent {...props} />}
    >
      {props.children}
    </Styled.MembersCanPopup>
  )
}
